import angular from 'angular';
import profileComponent from './profile.component';

let profileModule = angular.module('profile', [])
  .component('profile', profileComponent);

export default profileModule;



// WEBPACK FOOTER //
// ./client/pages/profile/profile.js